export enum CustomMessageType {
    CryptoAddress = 'address',
    PayOrder = 'order',
    SendCrypto = 'crypto',
    NFT = 'nft',
    SendNFT = 'transfer',
    SendRedeemable = 'redeemable',
    SendAsset = 'asset'

}